import { Icon } from '@fourthwall/components';
import React from 'react';
import { Link } from 'react-router-dom';
import * as S from './NewPostLinks.styled';
export const NewPostLinks = ({ links, getLinkHref }) => (React.createElement(S.Container, null, links.map((link) => (React.createElement(S.Link, { as: Link, to: getLinkHref(link) },
    React.createElement(Icon, { component: link.icon, height: 16 }))))));
